/**
 * @description
 * @author: 菩萨蛮
 * @date 2020/2/13 5:38 下午
 * @version V1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 */

const order = {
  data() {
    return {
      newDrawerVisible: false,
      modifyDrawerVisible: false,
      detailsDrawerVisible: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath.indexOf("modify-confirm-order") !== -1) {
      next(vm => {
        if (vm.$store.state.tab.update === true) {
          vm.qxTable.updateConfirmFlag++;
          vm.$store.commit('tab/afterUpdate');
        }
      });
    } else {
      next(vm => {
        if (vm.$store.state.tab.update === true) {
          vm.qxTable.updateFlag++;
          vm.$store.commit('tab/afterUpdate');
        }
      });
    }
  },
  methods: {
    showNewDrawer() {
      this.$router.push(`/new-${this.orderUrl}`);
    },
    closeNewDrawer(needUpdate) {
      this.newDrawerVisible = false;
      if (needUpdate) {
        this.tableFlagAdd();
      }
    },
    closeDetailsDrawer() {
      this.detailsDrawerVisible = false;
    },
    showDetailsDrawer() {
      this.detailsDrawerVisible = true;
    },
    showModifyDrawer() {
      this.modifyDrawerVisible = true;
    },
    closeModifyDrawer(needUpdate) {
      this.modifyDrawerVisible = false;
      if (needUpdate) {
        this.tableFlagAdd();
      }
    },
    async changeState(row, url, type) {
      const abortStr = `确定${type}${row.id}吗？`;
      const { code } = await this.qPut(`${this.qxTable.url}/${row.id}/${url}`, abortStr, `取消${type}`);
      if (code === 200) {
        this.$message.success(`${type}成功！`);
        this.tableFlagAdd();
      }
    }
  }
};

export default order;
